"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The DatasetMetrics model module.
 * @module model/DatasetMetrics
 * @version 0.2.0
 */
var DatasetMetrics = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>DatasetMetrics</code>.
   * @alias module:model/DatasetMetrics
   */
  function DatasetMetrics() {
    _classCallCheck(this, DatasetMetrics);

    DatasetMetrics.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(DatasetMetrics, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>DatasetMetrics</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DatasetMetrics} obj Optional instance to populate.
     * @return {module:model/DatasetMetrics} The populated <code>DatasetMetrics</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new DatasetMetrics();

        if (data.hasOwnProperty('code')) {
          obj['code'] = _ApiClient["default"].convertToType(data['code'], 'String');
        }

        if (data.hasOwnProperty('values')) {
          obj['values'] = _ApiClient["default"].convertToType(data['values'], ['Number']);
        }

        if (data.hasOwnProperty('listvalues')) {
          obj['listvalues'] = _ApiClient["default"].convertToType(data['listvalues'], [[Object]]);
        }

        if (data.hasOwnProperty('chartType')) {
          obj['chartType'] = _ApiClient["default"].convertToType(data['chartType'], 'String');
        }

        if (data.hasOwnProperty('columnStacking')) {
          obj['columnStacking'] = _ApiClient["default"].convertToType(data['columnStacking'], 'String');
        }
      }

      return obj;
    }
  }]);

  return DatasetMetrics;
}();
/**
 * This is the name/id of the metric.
 * @member {String} code
 */


DatasetMetrics.prototype['code'] = undefined;
/**
 * @member {Array.<Number>} values
 */

DatasetMetrics.prototype['values'] = undefined;
/**
 * @member {Array.<Array.<Object>>} listvalues
 */

DatasetMetrics.prototype['listvalues'] = undefined;
/**
 * @member {String} chartType
 */

DatasetMetrics.prototype['chartType'] = undefined;
/**
 * @member {String} columnStacking
 */

DatasetMetrics.prototype['columnStacking'] = undefined;
var _default = DatasetMetrics;
exports["default"] = _default;